import DiaryTimeCard from "../diaryTimeCard/DiaryTimeCard";
import "./DiaryTimeline.css";

/**
 * @function DiaryTimeLine
 * @param {Object} props - component props
 * @param {Array<Object>} props.data - list of timecard records
 * @param {Function} props.handleSelection - callback triggered when a timecard is selected
 * @returns {JSX.Element} - Groups timecard entries by hour and renders a timeline view
 */
function DiaryTimeLine({ data, handleSelection }) {
  /**
   * @type {Map<string, Array<Object>>}
   */
  const groups = new Map(); 

  if (Array.isArray(data)) {
    for (const value of data) {
      const [hh, rest] = String(value.time).split(":");    
      const [, ampm] = String(rest || "").split(" ");  
      const timeKey = `${hh}:00 ${ampm || ""}`.trim();

      /**
       * @type {Object}
      */
      const details = {
        project: value.project,
        activitytime: value.time,
        productivityMouse: value.mouseClicks,
        productivityKeys: value.keystrokes,
        screensrc: value.screenshotPath, 
        camsrc: value.webcamPath,
        date: value.minuteId.toString().split("T")[0],
        id: value.id,
        marked: value.marked,
        overtime: value.overtime,
        status: value.status,
        complianceFlag: value.complianceFlag,
        appInUse: value.appInUse,
        tabInUse: value.tabInUse,
      };

      if (!groups.has(timeKey)) groups.set(timeKey, []);
      groups.get(timeKey).push(details);
    }
  }

  return (
    <div className="container">
      {Array.from(groups.entries()).map(([timeKey, items]) => (
        <div className="diaryHours" key={timeKey}>
          {items.map((it) => (
            <DiaryTimeCard
              key={it.id ?? `${timeKey}-${it.activitytime}`} 
              project={it.project}
              appInUse={it.appInUse}
              tabInUse={it.tabInUse}
              activitytime={it.activitytime}
              productivityMouse={it.productivityMouse}
              productivityKeys={it.productivityKeys}
              screensrc={it.screensrc}
              camsrc={it.camsrc}
              date={it.date}
              id={it.id}
              marked={it.marked}
              overtime={it.overtime}
              status={it.status}
              complianceFlag={it.complianceFlag}
              handleSelection={handleSelection}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default DiaryTimeLine;
